import { InviteData } from '@shared/models/account.model';
import { UserInfo } from '@shared/models/auth.model';
import { AuthError } from '@auth/auth.enum';
import { StateToken } from '@ngxs/store';
import { ParsedToken } from 'firebase/auth';

export interface AuthStateModel {
  locked?: boolean | null;
  invite?: InviteData | null;
  userInfo: UserInfo | null;

  authToken: string | null;
  authState: string | null;
  authError?: AuthError | null;
  authClaims?: ParsedToken | null;
  authMfa?: object | null;

  loginUrl?: string | null;
  logoutUrl?: string | null;

  trialToken?: string | null;
}

export const AUTH_STATE_TOKEN = new StateToken<AuthStateModel>('auth');
